module.exports = __webpack_public_path__ + "static/AkzidenzGrotesk-Light-430149361214f3f1c642e6b036a2a1da.ttf";